/* eslint-disable no-dupe-keys */
export default {
  equipment_production: {
    name: '设备出厂信息',
    // 属性（一般与对象内容匹配）
    prop: {
      equipment_serial_number: '桩编号',
      equipment_nameplate_number: '桩铭牌号',
      sim: 'SIM卡号',
      rated_power: '桩功率',
      charge_module: '充电模块',
      internal_remark: '备注',
      status: '激活状态',
      activated_at: '激活时间',
      created_at: '出厂时间',
      updated_at: '更新时间',
      charge_station: '充电站',
      equipment_production_documents: '验收文档',
      information_clerk: '登记员',
      address: '地址',
      dispatch_status: '出库状态',
      device_test_reports: '测试记录',
      chargers_count: '枪数'
    },
    // Enum的属性
    statuses: {
      deactivated: '未激活',
      activated: '已激活'
    },
    dispatch_statuses: {
      true: '已出库',
      false: '未出库'
    },
    // 占位提示
    placeholder: {
      search_keyword: '桩编号/铭牌号/SIM卡号'
    },
    // 标签标题
    list_tabs: {
      all: '全部',
      dispatched: '已出库',
      undispatched: '未出库',
      activated: '已激活',
      deactivated: '未激活'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      production_info: '出厂信息',
      dispatch_info: '出库信息',
      equipment_production_documents: '验收文档',
      device_test_reports: '测试记录'
    },
    btns: {
      manage: '管理',
      qrcode: '生成二维码'
    },
    export_dialog: {
      qrcode_start_number: '起始编号',
      qrcode_start_number_placeholder: '例如:2025001',
      qrcode_equipment_count: '设备数量',
      equipment_type: '设备类型',
      equipment_types: {
        dc: '直流',
        ac: '交流'
      },
      scan_app: '扫码APP',
      is_support_third_party_app: '支持第三方',
      tips: {
        qrcode_generate: '生成 2025001xxx01、2025001xxx02'
      }
    },
    // 充电模块
    charge_modules: ['英飞源', '凌康', '易能时代', '昕感', '盛弘', '小可乐', '通合'],
    steps: {
      title: '出厂轨迹',
      equipment_production: '设备出厂',
      equipment_dispatch: '设备出库',
      equipment_activated: '设备激活'
    },
    device_test_reports: {
      device_sn: '采集器编号',
      charge_energy: '电量',
      start_time: '启动时间',
      end_time: '结束时间',
      amount: '金额',
      duration: '时长',
      reporter: '测试员'
    }
  }
}
